import { createAsyncThunk } from '@reduxjs/toolkit';

import { searchContentsFn } from '../common/thunks';
import type { ContentFilters, SearchContentsResponse } from '../common/types';

export const searchContents = createAsyncThunk<
  SearchContentsResponse,
  { offset: number; limit: number; filters: ContentFilters }
>('content/list/search', searchContentsFn);
